import { CommonEnums } from 'src/app/shared/common.enums';

export class Src_Inst {
    src_Inst_Id: number;
    dxMp_Id: number;
    dObj_Id: number;
    instNm: string;
    description: string;
    ver: string;
    nativeFlag: string;
    srcFltrCnd: string;
    srcFltrCndValid_Cd: string
    srcSelDistinctFlag: string
    tformCreateFlag: string;
    srcRowLimit: number;
    pl_Srt_Order: number;
    valid_Cd: string;
    updateBy: string;
    updateDt: Date;
    normalizeFlg: string;
    processOn: string;
    persistFlg: string;
    src_OverrideSql: string;
    src_OverrideSql_Flg: string
    src_OverrideSqlValid_Cd: string;
    group_Id: number;
    dobj_Attr_Id: number;
    body: string;
    endPointUrl: string;
    baseUrl: string;
    sqlHint: string;
    type: string;
    conn_Id: number;
    conn_Db_Id: number;
    dobj_AttrNm: string;
    gen_Tab_Valid_Cd: string;
    attr_Tab_Valid_Cd: string;
    dattr_Tab_Valid_Cd: string;
    prop_Tab_Valid_Cd: string;
    tmeRngeProp_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.src_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.dObj_Id = CommonEnums.defaults.LONG_VAL;
        this.instNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.nativeFlag = CommonEnums.defaults.STRING_VAL_YES;
        this.srcFltrCnd = CommonEnums.defaults.STRING_EMPTY;
        this.srcFltrCndValid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.srcSelDistinctFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.tformCreateFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.srcRowLimit = CommonEnums.defaults.LONG_VAL;
        this.pl_Srt_Order = CommonEnums.defaults.NUM_VAL;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.normalizeFlg = CommonEnums.defaults.STRING_VAL_YES;
        this.processOn = CommonEnums.defaults.DEFAULT_PROCESS_ON;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_OverrideSql = CommonEnums.defaults.STRING_EMPTY;
        this.src_OverrideSql_Flg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_OverrideSqlValid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.group_Id = CommonEnums.defaults.LONG_VAL;
        this.dobj_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.endPointUrl = CommonEnums.defaults.STRING_EMPTY;
        this.baseUrl = CommonEnums.defaults.STRING_EMPTY;
        this.sqlHint = CommonEnums.defaults.STRING_EMPTY;
        this.type = CommonEnums.defaults.DEFAULT_FORMAT_TYPE;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.body = CommonEnums.defaults.STRING_EMPTY;
        this.dobj_AttrNm = CommonEnums.defaults.STRING_EMPTY;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.dattr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.tmeRngeProp_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    getPrimaryKey(): string {
        return this.src_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Src_Inst {
        let src_InstTmp: Src_Inst = new Src_Inst();

        src_InstTmp.src_Inst_Id = this.src_Inst_Id;
        src_InstTmp.dxMp_Id = this.dxMp_Id;
        src_InstTmp.dObj_Id = this.dObj_Id;
        src_InstTmp.instNm = this.instNm;
        src_InstTmp.description = this.description;
        src_InstTmp.ver = this.ver;
        src_InstTmp.nativeFlag = this.nativeFlag;
        src_InstTmp.srcFltrCnd = this.srcFltrCnd;
        src_InstTmp.srcFltrCndValid_Cd = this.srcFltrCndValid_Cd;
        src_InstTmp.srcSelDistinctFlag = this.srcSelDistinctFlag;
        src_InstTmp.tformCreateFlag = this.tformCreateFlag;
        src_InstTmp.srcRowLimit = this.srcRowLimit;
        src_InstTmp.pl_Srt_Order = this.pl_Srt_Order;
        src_InstTmp.valid_Cd = this.valid_Cd;
        src_InstTmp.updateBy = this.updateBy;
        src_InstTmp.updateDt = this.updateDt;
        src_InstTmp.normalizeFlg = this.normalizeFlg;
        src_InstTmp.processOn = this.processOn;
        src_InstTmp.persistFlg = this.persistFlg;
        src_InstTmp.src_OverrideSql = this.src_OverrideSql;
        src_InstTmp.src_OverrideSql_Flg = this.src_OverrideSql_Flg;
        src_InstTmp.src_OverrideSqlValid_Cd = this.src_OverrideSqlValid_Cd;
        src_InstTmp.group_Id = this.group_Id;
        src_InstTmp.dobj_Attr_Id = this.dobj_Attr_Id;
        src_InstTmp.body = this.body;
        src_InstTmp.endPointUrl = this.endPointUrl;
        src_InstTmp.baseUrl = this.baseUrl;
        src_InstTmp.sqlHint = this.sqlHint;
        src_InstTmp.type = this.type;
        src_InstTmp.conn_Id = this.conn_Id;
        src_InstTmp.conn_Db_Id = this.conn_Db_Id;
        src_InstTmp.dobj_AttrNm = this.dobj_AttrNm;
        src_InstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        src_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;
        src_InstTmp.dattr_Tab_Valid_Cd = this.dattr_Tab_Valid_Cd;
        src_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;
        src_InstTmp.tmeRngeProp_Tab_Valid_Cd = this.tmeRngeProp_Tab_Valid_Cd;

        return src_InstTmp;
    }

    copyFrom(src_InstTmp: Src_Inst): void {
        this.src_Inst_Id = src_InstTmp.src_Inst_Id;
        this.dxMp_Id = src_InstTmp.dxMp_Id;
        this.dObj_Id = src_InstTmp.dObj_Id;
        this.instNm = src_InstTmp.instNm;
        this.description = src_InstTmp.description;
        this.ver = src_InstTmp.ver;
        this.nativeFlag = src_InstTmp.nativeFlag;
        this.srcFltrCnd = src_InstTmp.srcFltrCnd;
        this.srcFltrCndValid_Cd = src_InstTmp.srcFltrCndValid_Cd;
        this.srcSelDistinctFlag = src_InstTmp.srcSelDistinctFlag;
        this.tformCreateFlag = src_InstTmp.tformCreateFlag;
        this.srcRowLimit = src_InstTmp.srcRowLimit;
        this.pl_Srt_Order = src_InstTmp.pl_Srt_Order;
        this.valid_Cd = src_InstTmp.valid_Cd;
        this.updateBy = src_InstTmp.updateBy;
        this.updateDt = src_InstTmp.updateDt;
        this.normalizeFlg = src_InstTmp.normalizeFlg;
        this.processOn = src_InstTmp.processOn;
        this.persistFlg = src_InstTmp.persistFlg;
        this.src_OverrideSql = src_InstTmp.src_OverrideSql;
        this.src_OverrideSql_Flg = src_InstTmp.src_OverrideSql_Flg;
        this.src_OverrideSqlValid_Cd = src_InstTmp.src_OverrideSqlValid_Cd;
        this.group_Id = src_InstTmp.group_Id;
        this.dobj_Attr_Id = src_InstTmp.dobj_Attr_Id;
        this.body = src_InstTmp.body;
        this.endPointUrl = src_InstTmp.endPointUrl;
        this.baseUrl = src_InstTmp.baseUrl;
        this.sqlHint = src_InstTmp.sqlHint;
        this.type = src_InstTmp.type;
        this.conn_Id = src_InstTmp.conn_Id;
        this.conn_Db_Id = src_InstTmp.conn_Db_Id;
        this.dobj_AttrNm = src_InstTmp.dobj_AttrNm;
        this.gen_Tab_Valid_Cd = src_InstTmp.gen_Tab_Valid_Cd;
        this.attr_Tab_Valid_Cd = src_InstTmp.attr_Tab_Valid_Cd;
        this.dattr_Tab_Valid_Cd = src_InstTmp.dattr_Tab_Valid_Cd;
        this.prop_Tab_Valid_Cd = src_InstTmp.prop_Tab_Valid_Cd;
        this.tmeRngeProp_Tab_Valid_Cd = src_InstTmp.tmeRngeProp_Tab_Valid_Cd;
    }

    compare(src_InstTmp: Src_Inst): string {
        let src_InstString: string = this.toString(false);
        let src_InstTmpString: string = src_InstTmp.toString(false);

        if (src_InstString != src_InstTmpString) {
            return src_InstString + ',' + src_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = " Src_Inst [src_Inst_Id=" + this.src_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id +
            ", dObj_Id=" + this.dObj_Id +
            ", instNm=" + this.instNm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", nativeFlag=" + this.nativeFlag +
            ", srcFltrCnd=" + this.srcFltrCnd +
            ", srcFltrCndValid_Cd=" + this.srcFltrCndValid_Cd +
            ", srcSelDistinctFlag=" + this.srcSelDistinctFlag +
            ", tformCreateFlag=" + this.tformCreateFlag +
            ", srcRowLimi=" + this.srcRowLimit +
            ", pl_Srt_Order=" + this.pl_Srt_Order +
            ", valid_Cd=" + this.valid_Cd +
            ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt +
            ", normalizeFlg=" + this.normalizeFlg +
            ", processOn=" + this.processOn +
            ", persistFlg=" + this.persistFlg +
            ", src_OverrideSql=" + this.src_OverrideSql +
            ", src_OverrideSql_Flg=" + this.src_OverrideSql_Flg +
            ", src_OverrideSqlValid_Cd=" + this.src_OverrideSqlValid_Cd +
            ", group_Id=" + this.group_Id +
            ", dobj_Attr_Id=" + this.dobj_Attr_Id +
            ", body=" + this.body +
            ", endPointUrl=" + this.endPointUrl +
            ", baseUrl=" + this.baseUrl +
            ", sqlHint=" + this.sqlHint +
            ", type=" + this.type +
            ", conn_Id=" + this.conn_Id +
            ", conn_Db_Id=" + this.conn_Db_Id +
            ", dobj_AttrNm=" + this.dobj_AttrNm +
            ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd +
            ", dattr_Tab_Valid_Cd=" + this.dattr_Tab_Valid_Cd +
            ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd +
            ", tmeRngeProp_Tab_Valid_Cd=" + this.tmeRngeProp_Tab_Valid_Cd;
        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}